// extracted by mini-css-extract-plugin
export default {"row":"Students_row__UDxHD","tabl":"Students_tabl__zU6m0"};